import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import RoundedSearchTextField from "./RoundedSearchTextField";
import infoIcon from "../../images/InfoIconGray.svg";
import variables from "../../styles/base/_universal.scss";
import "./MultiSelectList.scss";

const MultiSelectList = ({
  data,
  open,
  enableSearch = true,
  handleSelection,
  selected,
  height = "100%",
  searchResults,
  inlineButton = false,
  handleSearch,
  inputValue = "",
  placeholder,
  setIsSearchBarEmpty,
  multiple,
  handleClose,
  title,
  isPdfFlow = false,
}) => {
  // const isSelected = (element) => {
  //   return multiple && selected[title.toLowerCase()]?.findIndex((el) => element.id === el.id) > -1;
  // };

  const isSelected = (item, key) => {
    const flattened = selected[title.toLowerCase()]?.flat() || [];
    return flattened.some((i) => i.name === item.name);
  };
  return (
    <div style={{ paddingTop: "12px" }}>
      {enableSearch && !isPdfFlow && (
        <div style={{ margin: "0px 16px" }}>
          <RoundedSearchTextField
            onTextChange={searchResults}
            handleSearch={(type) => {
              if (inlineButton) {
                handleSearch(type);
              }
            }}
            inlineButton={inlineButton}
            inputValue={inputValue}
            placeholder={placeholder}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
          />
        </div>
      )}
      <div
        className="multi-select-list custonScrollBar"
        style={{ height: height }}
      >
        {data?.length === 0 && (
          <div
            style={{
              margin: "14px 16px",
              fontSize: variables.fontSmall,
              color: variables.grayFilterColor,
              display: "flex",
            }}
          >
            <img
              src={infoIcon}
              alt="Info"
              style={{ marginRight: "6px", marginBottom: "30px" }}
            />
            <p> No Result Found, Try Using Different Keywords</p>
          </div>
        )}

        <MenuList autoFocusItem={open} id="menu-list-grow">
          <div></div>
          {data?.map((option) => (
            <MenuItem
              key={option?.id}
              onMouseDown={(e) => {
                e.preventDefault();
              }}
              //onClick={(e) => e.preventDefault()}
              onBlur={(e) => e.preventDefault()}
              onClick={(e) => {
                handleSelection(!isSelected(option), option, title);
                multiple && handleClose();
              }}
              //className={`menu-items  `}
              className={`menu-items ${
                option === option?.name
                  ? "blue-background"
                  : "no-blue-background"
              }`}
            >
              {multiple ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      key={option.id}
                      className="checkBox"
                      onChange={(ev) => {
                        handleSelection(ev.target.checked, option, title);
                      }}
                      name={option.name || option.name}
                      color="primary"
                      size="small"
                      checked={isSelected(option)} // show already selected item
                    />
                  }
                  label={option.name || option.name}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              ) : (
                option?.name || option
              )}
            </MenuItem>
          ))}
        </MenuList>
      </div>
    </div>
  );
};

export default MultiSelectList;
